import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";
import { Briefcase, MessageCircle, Users, Calendar } from "lucide-react";
import { waLink } from "../lib/wa";

export default function CorporateEnquiry() {
  const [form, setForm] = useState({ brand: "", event: "", date: "", mates: 3, contact: "", notes: "" });
  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.brand || !form.contact) {
      toast.error("Brand name and contact are required");
      return;
    }
    const text = `Hi HeylpMate! Corporate enquiry:
• Brand: ${form.brand}
• Event / Purpose: ${form.event || "(not specified)"}
• Date: ${form.date || "(flexible)"}
• Mates needed: ${form.mates}
• Contact: ${form.contact}
• Notes: ${form.notes || "-"}`;
    window.open(waLink(text), "_blank");
    toast.success("Opening WhatsApp — we'll reply within an hour");
  };

  return (
    <div className="max-w-4xl mx-auto px-5 md:px-8 py-14 md:py-20">
      <div className="text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 chip" style={{ borderColor: "var(--secondary)", color: "var(--secondary)" }}>
          <Briefcase className="w-3.5 h-3.5" /> Corporate · Bulk
        </div>
        <h1 className="font-display text-5xl md:text-6xl font-bold mt-4 leading-tight">
          Bulk hire Mates for your <span className="italic" style={{ color: "var(--secondary)" }}>exhibition</span>.
        </h1>
        <p className="mt-4 text-[color:var(--text-muted)]">
          Product marketing, brand promotion, booth support, on-ground volunteers — from 3 to 50 Mates. Real WhatsApp quote within an hour.
        </p>
      </div>

      <form onSubmit={submit} className="mt-10 rounded-3xl border border-black/10 bg-white p-6 md:p-10 space-y-5">
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs uppercase tracking-widest text-neutral-500">Brand / Company</Label>
            <Input data-testid="corp-brand" className="mt-1.5" value={form.brand} onChange={upd("brand")} required />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-neutral-500">Event / Purpose</Label>
            <Input data-testid="corp-event" className="mt-1.5" placeholder="Exhibition, product launch, mall activation…" value={form.event} onChange={upd("event")} />
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs uppercase tracking-widest text-neutral-500 flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> Date</Label>
            <Input data-testid="corp-date" type="date" className="mt-1.5" value={form.date} onChange={upd("date")} />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest text-neutral-500 flex items-center gap-1"><Users className="w-3.5 h-3.5" /> Mates needed</Label>
            <Input data-testid="corp-mates" type="number" min="1" max="50" className="mt-1.5" value={form.mates} onChange={upd("mates")} />
          </div>
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-neutral-500">Your WhatsApp / phone / email</Label>
          <Input data-testid="corp-contact" className="mt-1.5" placeholder="+91…" value={form.contact} onChange={upd("contact")} required />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-widest text-neutral-500">Notes</Label>
          <Textarea data-testid="corp-notes" rows={3} className="mt-1.5" value={form.notes} onChange={upd("notes")} placeholder="Skills needed, dress code, timing…" />
        </div>
        <button data-testid="corp-submit" className="btn-primary w-full inline-flex items-center justify-center gap-2">
          <MessageCircle className="w-4 h-4" /> Send WhatsApp Enquiry
        </button>
        <p className="text-[11px] text-neutral-500 text-center">We reply within one hour on business days.</p>
      </form>
    </div>
  );
}
